import { useEffect, useState } from "react";
import Address from "../../components/Address";
import NoticeBoard from "../../components/customer_support/NoticeBoard";
import { MenuBar } from "../../components/MenuBar";
import { getPostList, getPostPageCount } from "../../services/CustomerAPI";
import "../ContentFrame.css";
import "../Main.css";

export const Sales = () => {
  const [currentPostPage, setCurrentPostPage] = useState();
  const [postCount, setPostCount] = useState();
  const [postList, setPostList] = useState([]);

  const goPost = () => {
    window.location.href = "/customer/post";
  };

  const changePage = (selected) => {
    window.location.href = `/customer/sales?page=${selected.selected + 1}`;
  };

  useEffect(() => {
    if (
      window.location.href.split("?page=").length !== 2 ||
      isNaN(window.location.href.split("?page=")[1])
    ) {
      window.location.href = `/customer/sales?page=1`;
    }
    setCurrentPostPage(window.location.href.split("page=")[1] - 1);
    getPostPageCount("SALE").then((response) => {
      setPostCount(response.data);
    });
  }, []);

  useEffect(() => {
    if (currentPostPage !== undefined) {
      if (currentPostPage < 0) {
        window.location.href = `/customer/sales?page=1`;
      }
      getPostList(currentPostPage, "SALE").then((response) => {
        if (response.data.length === 0 && currentPostPage > 0) {
          getPostPageCount("SALE").then((res) => {
            window.location.href = `/customer/sales?page=${res.data}`;
          });
        }
        setPostList(response.data);
      });
    }
  }, [currentPostPage]);

  return (
    <div className="h-screen w-screen min-w-[1200px]">
      <MenuBar selected_page={8} />
      <div className="w-full h-full bg-white">
        <div className="common_frame_container">
          <div className="common_content_container">
            <div style={{ width: "100%", height: "100px" }}></div>
            <span className="page_title">영업상담</span>
            <NoticeBoard
              postList={postList}
              goPost={goPost}
              changePage={changePage}
              currentPostPage={currentPostPage}
              type={"sales"}
              postCount={postCount}
            />
            <div style={{ width: "100%", height: "100px" }}></div>
          </div>
        </div>
      </div>
      <Address />
    </div>
  );
};
